import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';
import ItemSelectorPage from './ItemSelectorPage';
import DoorPage from './DoorPage';
import WindowPage from './WindowPage';
import ConservatoryPage from './ConservatoryPage';
import AdditionalPage from './AdditionalPage';


class ItemBuilderPage extends Component {
    render() {
        return (
            <Switch>
                <Route path="/Item/Selector" component={ItemSelectorPage} />
                <Route path="/Item/Door" component={DoorPage} />
                <Route path="/Item/Additional" component={AdditionalPage} />
                <Route path="/Item/Window" component={WindowPage} />
                <Route path="/Item/Conservatory" component={ConservatoryPage} />
            </Switch>
        );
    }
}

export default ItemBuilderPage;



// WEBPACK FOOTER //
// ./src/containers/ItemBuilderPage.js